const Spacer = ({ height }) => (
  <div className='u-spacer' style={height ? { height: height } : null} />
)

export default Spacer
